var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.902344,
    y: 0.650879,
    width: 64.3944,
    height: 64,
    rx: 20,
    fill: "#FC6AD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5129_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8184 35.7231L30.9355 48.9028C31.5215 49.4496 32.2949 49.7543 33.0996 49.7543C33.9043 49.7543 34.6777 49.4496 35.2637 48.9028L49.3809 35.7231C51.7559 33.5121 53.0996 30.4106 53.0996 27.1684V26.7153C53.0996 21.2543 49.1543 16.5981 43.7715 15.6996C40.209 15.1059 36.584 16.2699 34.0371 18.8168L33.0996 19.7543L32.1621 18.8168C29.6152 16.2699 25.9902 15.1059 22.4277 15.6996C17.0449 16.5981 13.0996 21.2543 13.0996 26.7153V27.1684C13.0996 30.4106 14.4434 33.5121 16.8184 35.7231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5129_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(13.0996 12.6509)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.24d916b699369fd6c1e8c4d810924306.svg";
export { ForwardRef as ReactComponent };